const baseUrl = () => {
    //正式
    let dev = 'https://xqcc.site/rou'
    // let dev = 'https://localhost:9001/rou'
    return dev
}

export {baseUrl}